import { connect } from 'react-redux'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect } from 'react'
import { withRouter } from 'react-router'
import { CustomDataTableHeader, CustomPanel, PageHeader, ThreeDots } from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import ModalMotivoAtraso from './ModalMotivoAtraso/ModalMotivoAtraso'
import useMotivoAtraso, { LOAD_MESSAGE } from './MotivoAtrasoHook'
import { tableCellCentered } from '../../../../assets/js/styles'

function MotivoAtraso({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useMotivoAtraso()

  useEffect(() => {
    localDispatch.getMotivosAtraso(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_MOTIVOS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getMotivosAtraso(selectedTp)
        break

      case LOAD_MESSAGE.DELETE_MOTIVO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.deleteMotivoAtraso(state.selectedMotivo)
        break

      case LOAD_MESSAGE.DELETE_SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>2.11 - Motivo de Atraso</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => localDispatch.onBtnClickNovo()} onVoltar={history.goBack}>
          <DataTable
            value={state.motivos}
            paginator={true}
            rows={10}
            emptyMessage={'Sem motivos para exibir'}
            header={
              <CustomDataTableHeader
                onChange={value => localDispatch.onGlobalFilterChange(value)}
              />
            }
            globalFilter={state.globalFilter}
            style={{ textAlign: state.motivos.length > 0 ? 'start' : 'center' }}
          >
            <Column field="id" header="Código" style={{ textAlign: 'center', width: 150 }} />
            <Column field="name" header="Nome" />
            <Column field="type" header="Tipo" style={tableCellCentered(150)} />
            <Column
              header="Menu"
              style={tableCellCentered(70)}
              body={motivo => (
                <ThreeDots
                  items={['Editar', 'Apagar']}
                  onClick={item => localDispatch.onMenuItemClicked(item, motivo)}
                />
              )}
              bodyStyle={tableCellCentered()}
            />
          </DataTable>
        </CustomPanel>
      </div>
      <ModalMotivoAtraso
        show={state.modal.show}
        data={state.modal.data}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(MotivoAtraso))
